/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const initialState = {
  data: [],
  isLoading: false,
  status: "INITIAL",
};

const QuotaReducer = (state = initialState, action) => {
  if (action.type === "QUOTA/PENDING") {
    return {
      ...state,
      status: "PENDING",
      isLoading: true,
    };
  }
  if (action.type === "QUOTA/SUCCESS") {
    return {
      data: action.payload,
      status: "SUCCESS",
      isLoading: false,
    };
  }
  if (action.type === "QUOTA/FAILED") {
    return {
      ...state,
      status: "FAILED",
      isLoading: false,
    };
  }
  return state;
};

export default QuotaReducer;
